import banner1Dsktp from '../../assets/img/desktop/banner-slide-1.png';
import banner2Dsktp from '../../assets/img/desktop/banner-slide-2.png';
import banner1Mobile from '../../assets/img/mobile/banner-slide-1-mobile.png';
import banner2Mobile from '../../assets/img/mobile/banner-slide-2-mobile.png';
import logoCartao from '../../assets/svgs/cdtteam-logo-large-desktop-1.svg';
import cartaoModal from '../../assets/img/desktop/cdtteam-mockup-modal.png';
import bgPrecoDesk from '../../assets/img/desktop/cdtteam-bg-preco-desktop.png';
import bgPrecoMobile from '../../assets/img/mobile/cdtteam-bg-preco-mobile.png';
import cartaoPreco from '../../assets/img/desktop/cdtteam-mockup-preco.png';
import teamShield from '../../assets/svgs/cdtteam-shield.svg';
import bgFaqDesk from '../../assets/img/desktop/cdtteam-bg-faq-desktop.png';
import bgFaqMobile from '../../assets/img/mobile/cdtteam-bg-faq-mobile.png';
import bgBeneficioDesk from '../../assets/img/desktop/cdtteam-bg-beneficio-desktop.png';
import bgBeneficioMobile from '../../assets/img/mobile/cdtteam-bg-beneficio-mobile.png';

const CARD_MONTHLY_FEE = "{{valor_mensalidade}}";
const APPOINTMENT_GP = "{{valor_clinicogeral}}";
const APPOINTMENT_SP = "{{valor_demaisespecialidades}}";

const TEAM_NAME = "Santa Cruz";
const SALES_URL = "https://torcedores.cartaodetodos.com.br/dados-pessoais/?idserv=48"
const TWITTER_URL = "https://bit.ly/3NB5ayj"
const INSTAGRAM_URL = "https://bit.ly/3R648x"
const FACEBOOK_URL = "https://bit.ly/3a4v7IZ"
const SITE_URL = "https://www.cartaodetodos.com.br/"

const API_ENDPOINT = "https://api.cdt.casadebraganca.com";
export const API_LIST_STATES_BY_CATEGORY = `${API_ENDPOINT}/ListarEstadosPorCategoria`;
export const API_FILTER_PARTNERS = `${API_ENDPOINT}/FiltrarParceiros`;
export const API_LIST_CATEGORIES = `${API_ENDPOINT}/ListarCategorias`;


export const staticCampaignData = {
  teamShield,
  logoCartao: logoCartao,
  teamName: TEAM_NAME,
  salesUrl: SALES_URL,
  banners: [
    {
      img: { desktop: banner1Dsktp, mobile: banner1Mobile },
      title: "Campeão na saúde",
      subtitle: `Consultas com clínico geral por R$ ${APPOINTMENT_GP} e demais especialidades, R$ ${APPOINTMENT_SP}. Tudo por apenas R$ ${CARD_MONTHLY_FEE} mensais para toda a família.`
    }, {
      img: { desktop: banner2Dsktp, mobile: banner2Mobile },
      title: "Especiais",
      subtitle: `Em breve compartilharemos descontos em benefícios especiais  para os filiados ao Cartão de TODOS ${TEAM_NAME}.` 
    }],
  modal: {
    img: cartaoModal,
    title: "Bem-vindo, Tricolor!",
    description: `Maior cartão de descontos do Brasil, o Cartão de TODOS agora também é o cartão da Família Tricolor, oferecendo acesso a serviços de saúde, educação e lazer por apenas R$ ${CARD_MONTHLY_FEE} mensais para todos da família. Pra cima, Santa!`,
  },
  imgs: {
    preco: { bgDesktop: bgPrecoDesk, bgMobile: bgPrecoMobile, cartaoPreco },
    faq: { bgDesktop: bgFaqDesk, bgMobile: bgFaqMobile },
    beneficio: { bgDesktop: bgBeneficioDesk, bgMobile: bgBeneficioMobile }
  },
  socials: {
    site: SITE_URL,
    twitter: TWITTER_URL,
    facebook: FACEBOOK_URL,
    instagram: INSTAGRAM_URL,
  }
} as const;
